export const badge = {
  MuiBadge: {
    styleOverrides: {
      dot: {
        width: 10,
        height: 10,
        borderRadius: '50%',
      },
    },
  },
};
